export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/default-rzxxw-9f8effb31f413c51d7657066401a8f1e.webp";